import { useEffect } from "react";
import api from "@/lib/api";

function setMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function SeoManager() {
  useEffect(() => {
    api
      .get("/settings/seo")
      .then(({ data }) => {
        if (data.page_title) document.title = data.page_title;
        setMeta("description", data.meta_description);
        setMeta("keywords", data.meta_keywords);
      })
      .catch(() => {});
  }, []);
  return null;
}
